import { BadgeUserAccountStatus, CommaSeparator, HeaderTitlePage, LabelCoins, LabelGender, Username } from '@/components/custom';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { Badge, Separator } from '@/components/ui';
import { IHasUserData } from '@/interfaces';
import { useUserConnected } from '@/hooks';
import { dayjs } from '@/config';

type TProps = IHasUserData & {
  hideSeparator?: boolean;
};

const UserProfileDetailsHeader = ({ userData, hideSeparator }: TProps) => {

  const { hasPermissions } = useUserConnected();

  const hideEmail = !hasPermissions(AdminUserPermissionsEnum.USERS);

  const description = (
    <div className='flex flex-col'>
      <div className='flex items-center'>
        {
          !hideEmail
            ? <p>
              {userData.email}
            </p>
            : <UserProfileDetailsHeaderGender userData={userData} />
        }
        <div className='ml-auto flex flex-wrap items-center justify-end gap-1'>
          {
            userData.deletedAppAt &&
            <Badge
              variant='outline'
              className='px-2 py-0.5 text-sm rounded-sm border-0 text-white bg-neutral-500'>
              Désinstallée depuis le {dayjs(userData.deletedAppAt).format('DD/MM/YYYY')}
            </Badge>
          }
          {
            userData.notificationsOff &&
            <Badge
              variant='outline'
              className='px-2 py-0.5 text-sm rounded-sm border-0 text-white bg-yellow-500'>
              Notifications coupées
            </Badge>
          }
          <BadgeUserAccountStatus
            className='px-2 py-0.5 text-sm rounded-sm'
            user={userData} />
        </div>
      </div>
      {
        (!hideEmail || userData.lastSeen) &&
        <div className='flex flex-col space-y-1 mt-1'>
          {
            !hideEmail &&
            <UserProfileDetailsHeaderGender userData={userData} />
          }
          {
            userData.lastSeen &&
            <p className={'flex space-x-1 text-sm italic text-muted-foreground'}>
              <span>
                Connecté
              </span>
              <span>
                {dayjs().locale('fr').to(dayjs(userData.lastSeen))}
              </span>
            </p>
          }
        </div>
      }
    </div>
  );

  const title = (
    <div className='flex flex-col justify-center'>
      <Username
        user={userData}
        badgeSize={25}
        className='text-2xl' />
    </div>
  );

  return (
    <div className='flex flex-col space-y-3'>
      <HeaderTitlePage
        description={description}
        title={title} />
      {
        !hideSeparator &&
        <Separator className='bg-muted' />
      }
    </div>
  );

};

const UserProfileDetailsHeaderGender = ({ userData }: IHasUserData) => (
  <div className='flex items-center space-x-1'>
    <LabelGender
      countryIso3={userData.countryIso3}
      gender={userData.gender} />
    <CommaSeparator />
    <LabelCoins
      coins={userData.coins}
      diamondWallet={userData.diamondWallet} />
  </div>
);

export default UserProfileDetailsHeader;
